export enum GrantTypeEnum {
    FIJO = 'FIJO',
    PERCIBIDO = 'PERCIBIDO'
}